import React, {
  createContext, useCallback, useContext, useEffect, useState,
} from 'react';
import { useDispatch } from 'react-redux';
import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import PropTypes from 'prop-types';
import { setCustomerId } from '../../slices/accounts';
import awsconfig from '../../aws-exports';

Amplify.configure(awsconfig);

const AuthContext = createContext({});

export const AuthContextProvider = ({ children }) => {
  const [sessionChecked, setSessionChecked] = useState(false);
  const dispatch = useDispatch();

  const currentSession = useCallback(async () => {
    try {
      const session = await fetchAuthSession();
      const customerId = session.tokens?.idToken?.payload?.customerId;
      dispatch(setCustomerId(customerId));
    } catch (err) {
      dispatch(setCustomerId(null));
    }

    setSessionChecked(true);
  }, [dispatch]);

  useEffect(() => {
    currentSession();
  }, [currentSession]);

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <AuthContext.Provider value={{}}>
      {sessionChecked ? children : null}
    </AuthContext.Provider>
  );
};

AuthContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export const useAuthContext = () => useContext(AuthContext);
